import { LitElement, html, css } from 'lit';
import { nothing } from 'lit';
import { accessibility, grid, details, dialog } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { EventManager } from '../../utilities/events';
import { cache } from 'lit/directives/cache.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { dateToMaybeRange, processEventData, processProvisionData, formatDateString, currencyFormatter } from '../../utilities/eventUtilities';
import { address, provisionIcon, yellowTick, expandIcon, collapseIcon, arrow, calendar, ticket, arrowBack, icons, web, deleteIcon } from '../../utilities/icons';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInEvent extends LitElement {
    static properties = {
        name: { type: String },
        organisation: { type: String },
        location: { type: String },
        event: { type: String },
        preview: { type: String },
        eventData: { type: Array },
        action: { type: String },
        nonce: { type: String },
        restUrl: { type: String },
        icons: { type: Array },
        allProvisions: { type: Array },
        config_hardlinks: { type: Object, reflect: true },
        hardlinks: { type: Object, state: true },
        _eventData: { state: true, type: Array },
        _provisionData: { state: true, type: Array },
        _eventProvisions: { state: true, type: Array },
        _selectedImage: { state: true, type: String },
        _eventProvisionsKeyed: { state: true, type: Object },
        membership: { type: Object },
        _showShareModal: { state: true, type: Boolean },
        _isSharingProfile: { state: true, type: Boolean },
        memberAlreadySharedProfileText: { type: String },
        memberShareButtonTextForEvent: { type: String },
        memberShareModalTextForEvent: { type: String },
    };
    constructor() {
        super();
        this._showShareModal = false;
        this._isSharingProfile = false;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        if (!this.allProvisions) {
            await this._fetchAllProvisions();
        }
        if (!this.locationData || this.locationData.length == 0) {
            if (this.preview) {
                if (!this.eventData || this.eventData.length == 0) {
                    await this._fetchEvent();
                }
                this.location = this.eventData?.location?.id;
                await this._fetchProvisions();
            }
            else {
                await this._fetchPublicLocation();
                let provisions = this.locationData?.provisions ?? [];
                this.provisionData = this.allProvisions.map((item) => {
                    let newProv = { title: item.title, provisions: [] };
                    item.provisions.forEach((provision) => {
                        let provId = provision.id;
                        let existingProvision = provisions.find((prov) => prov.standardId == provId);
                        if (existingProvision) {
                            existingProvision.name = provision.name;
                            newProv.provisions.push(existingProvision);
                        }
                    });
                    return newProv;
                });
            }
            if (!this._eventProvisions) {
                await this._fetchAllEventProvisions();
            }
            this._eventProvisionsKeyed = {};
            this._eventProvisions.forEach((provision) => {
                provision.provisions.forEach((p) => {
                    this._eventProvisionsKeyed[p.id] = p;
                });
            });
        }
        this.location = this.eventData?.location?.id;
        this.organisation = this.eventData?.location?.organisation?.id;
        this._setEventData();
        if (!this._selectedImage) {
            this._selectedImage = 'photo1';
        }
        if (this.config_hardlinks) {
            this.hardlinks = this.config_hardlinks;
        }
        this.config_hardlinks = null;
        cardLinks(this.shadowRoot);
    }
    firstUpdated() {
        if (!this.preview) {
            window.scrollTo(0, 0);
            this.eventManager.emit(`allin-header-${this.name}`, { name: this.name, text: `${this.eventData.name}` });
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('_eventData')) {
            this._setSidebar();
        }
        cardLinks(this.shadowRoot);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    get _modal() {
        return this.shadowRoot.querySelector('dialog');
    }
    /* updated(changedProperties){

    } */
    render() {
        let main = '';
        if (!this._eventData || this._eventData.length == 0) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else {
            let notice = '';
            if (this.eventData.status == 'Draft') {
                notice = html `<p class="message">This preview is in draft mode and won't be visible to the public.</p>`;
            }
            let loop = [];
            let images = [this._eventData.find((item) => item.name == this._selectedImage), this._eventData.find((item) => item.name == 'photo1'), this._eventData.find((item) => item.name == 'photo2'), this._eventData.find((item) => item.name == 'photo3')];
            images = images.filter((item) => item && item.value);
            if (images.length > 0) {
                if (images.length == 2) {
                    images = [images[0]];
                }
                images.forEach((image, i) => {
                    if (i == 0) {
                        loop.push(html `\n                            <div class="item grid--featured">\n                                <img src="${image.value.publicUrl}" alt="${image.value.altText}" />\n                                <allin-alt-block description="${image.value.altText}" uid="alt_${i}"></allin-alt-block>\n                            </div>`);
                    }
                    else {
                        loop.push(html `\n                            <div class="card item grid--image ${image.name == this._selectedImage ? 'selected' : ''}">\n                                <img src="${image.value.publicUrl}" alt="${image.value.altText}"/>\n                                <a href="#" class="card_target" @click=${(e) => { e.preventDefault(); this._selectedImage = image.name; }}>\n                                    <span class="screen-reader-text">View ${image.name}></span>\n                                </a>\n                            </div>`);
                    }
                });
            }
            let instancesLoop = [];
            let hasLinks = false;
            this.eventData?.instances.forEach((instance) => {
                let startDate = formatDateString(instance.start, true);
                let dateString = startDate[0];
                let compareDate = instance.end ? new Date(instance.start) : new Date(instance.start);
                let now = new Date();
                if (compareDate < now) {
                    return;
                }
                if (instance?.end && instance?.start?.slice(0, 10) !== instance?.end?.slice(0, 10)) {
                    let endDate = formatDateString(instance.end, true);
                    dateString = dateToMaybeRange(instance.start, instance.end);
                }
                if (instance?.start && instance?.end && instance?.start?.slice(0, 10) === instance?.end?.slice(0, 10)) {
                    dateString = startDate[0];
                }
                if (instance.bookingLink) {
                    hasLinks = true;
                }
                let provisions = instance.provisions ?? [];
                let zoneProvisions = instance.zone?.provisions ?? [];
                provisions = provisions.concat(zoneProvisions);
                provisions = provisions.sort((a, b) => {
                    let aname = this._eventProvisionsKeyed[a.standardId]?.name ?? '';
                    let bname = this._eventProvisionsKeyed[b.standardId]?.name ?? '';
                    return aname.localeCompare(bname);
                });
                let provisionsAdded = [];
                let iconList = [];
                let provisionLoop = provisions?.map((provision) => {
                    if (provisionsAdded.includes(provision.standardId)) {
                        return '';
                    }
                    let name = this._eventProvisionsKeyed[provision.standardId]?.name ?? '';
                    if (!name) {
                        name = this._eventProvisionsKeyed[provision.id]?.name ?? '';
                    }
                    if (!name) {
                        return '';
                    }
                    provisionsAdded.push(provision.standardId);
                    let slug = name.toLowerCase().replace(/[\s+\-+]/g, '_').replace(/[^\w]/g, '');
                    let icon = slug + '.svg';
                    iconList.push({ icon: icon, alt: name });
                    return html `<li class="provision grid grid--icon">\n                        <a href="#${slug}">\n                            <span class="screen-reader-text">Find out more about the ${name} provision</span>\n                            <span aria-hidden="true" class="icon"><img src="/wp-content/themes/ace/assets/icons/event_provisions/${icon}" alt="${name.replace(/\s+/g, '_').replace(/[^\w]/g, '')}" alt=""/></span>\n                        </a>\n                        <div class="provision_text">\n                            <h4>${name}</h4>\n                            <allin-markdown-editor readonly value="${provision.description}"></allin-markdown-editor>\n                        </div>\n                    </li>`;
                });
                provisionLoop = provisionLoop.filter((item) => item);
                let provisionStr = '';
                if (provisionLoop && provisionLoop.length > 0) {
                    provisionStr = html `\n                        <details class="provisions">\n                            <summary><span class="screen-reader-text">Provisions for the ${dateString} instance of this event</span><div class="flex provision-icons" aria-hidden="true">${iconList.map(icon => html `<span class="provision-icon" title="${icon.alt}"><img src="/wp-content/themes/ace/assets/icons/event_provisions/${icon.icon}" alt="${icon.alt}"/></span>`)}</div></summary>\n                            <div class="panel">\n                                <ul>\n                                    ${provisionLoop}\n                                </ul>\n                            </div>\n                        </details>`;
                }
                let zoneStr = instance.zone ? html ` ${instance.zone.name}` : '';
                instancesLoop.push(html `<li class="instance">\n                        <div class="grid grid_50 instance_title_grid">\n                            <h3>${dateString}<br/>${startDate[1]}</h3>\n                            <h3>${zoneStr}</h3>\n                        </div>\n                        ${instance.bookingLink ? html `<a href="${instance.bookingLink}" class="arrow" rel="noopener">Book this time<span aria-hidden="true">${arrow}</span></a>` : html `<span></span>`}\n                        ${provisionStr}\n                    </li>`);
            });
            let instances = html `\n            <div class="flex space-between align-center wrap">\n                <h2>Dates and times</h2>\n                <div class="collapsers">\n                    <button class="expand_all" @click=${this._expandCollapseAll}>${expandIcon}Expand all</button>\n                    <button class="collapse_all" @click=${this._expandCollapseAll}>${collapseIcon}Collapse all</button>\n                </div>\n            </div>\n            <div class="bg instances">\n                <ul class="instance-list">\n                    ${instancesLoop.length ? instancesLoop : html `<li>There are no upcoming instances of this event.</li>`}\n                </ul>\n                ${this.eventData?.defaultBookingLink && instancesLoop.length ? html `<a href="${this.eventData.defaultBookingLink}" class="button" rel="noopener">Book now</a>` : ''}\n            </div>`;
            let description = this._eventData.find((item) => item.name == 'description');
            let text = html `\n               <div class="description"><allin-markdown-editor value="${description ? description?.value : ''}" readonly></allin-markdown-editor></div>`;
            let backToSearch = this.preview ? '' : html `<div class="return back-to-search">\n                        <a href="#" class="back-to-search-btn" @click=${this._handleGoBack}><span aria-hidden=true>${arrowBack}</span>Go back to search</a>\n                    </div>`;
            main = html `\n                ${notice}\n                <div class="location">\n                    <div class="image-grid">${loop}</div>\n                    <div class="location_text">\n                        <h2>${this.eventData.name}</h2>\n                        ${text}\n                    </div>\n                    ${instances}\n                    ${backToSearch}\n                </div>\n                <dialog>\n                    <button class="close" autofocus @click=${this._handleShareProfile}><span aria-hidden="true">${deleteIcon}</span>Cancel</button>\n                    ${this._isSharingProfile ? html `\n                        <div class="loading" aria-live="polite">\n                            <span class="loading_message">Please wait. Sharing</span>\n                        </div>\n                    ` : html `\n                        <p>${this.memberShareModalTextForEvent || `You are about to share your details with ${this.eventData?.location?.organisation.name}.`}</p>\n                        <button class="btn" @click=${this._cancelShareProfile}>Cancel</button>\n                        <button class="btn" @click=${this._confirmShareProfile}>Confirm</button>\n                    `}\n                </dialog>\n            `;
        }
        return html `${main}`;
    }
    _handleClick(e) {
        e.preventDefault();
        this.eventManager.emit(`allin-organisation-event-form-edit-${this.name}`, { eventId: this.event });
    }
    async _fetchEvent() {
        let url = `${this.restUrl}?org_id=${this.organisation}&action=${this.action}-event&event_id=${this.event}&nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            this.eventData = data.event;
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    async _fetchProvisions() {
        if (this.location) {
            let url = `${this.restUrl}?org_id=${this.organisation}&action=${this.action}-provisions&location_id=${this.location}&nonce=${this.nonce}`;
            try {
                let response = await fetch(url, {
                    headers: {
                        'AllIn-Nonce': this.nonce,
                    }
                });
                //show logged out modal if session has expired
                if (response.status === 403) {
                    handle403s();
                    return;
                }
                let data = await response.json();
                this.provisionData = data.provisions;
                this.provisionData = processProvisionData(this.provisionData);
            }
            catch (error) {
                console.error('Error:', error);
            }
            ;
        }
        else {
            this.provisionData = [];
        }
    }
    async _fetchAllProvisions() {
        try {
            const response = await fetch(`${this.restUrl}?action=get_all_provisions`, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            if (data) {
                this.allProvisions = data.provisions ?? [];
            }
        }
        catch (error) {
            console.error('Error fetching all provisions:', error);
        }
    }
    async _fetchAllEventProvisions() {
        try {
            const response = await fetch(`${this.restUrl}?action=get_all_event_provisions`, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            if (data) {
                this._eventProvisions = data.eventProvisions ?? [];
            }
        }
        catch (error) {
            console.error('Error fetching all provisions:', error);
        }
    }
    async _fetchPublicLocation() {
        try {
            const response = await fetch(`${this.restUrl}?action=get_location&location_id=${this.location}`, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            this.locationData = data;
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    async _setEventData() {
        this._eventData = processEventData(this.eventData);
    }
    _setSidebar() {
        let loop = [];
        let start = this.eventData?.firstInstance?.start ?? this.eventData.firstInstance;
        let end = this.eventData?.lastInstance?.start ?? this.eventData.lastInstance;
        let dateString = dateToMaybeRange(start, end);
        if (dateString) {
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${calendar}</div>\n                    <div class="icon_text">\n                        <p><strong>Dates:</strong></p>\n                        <p>${dateString}</p>\n                    </div>\n                </div>`);
        }
        let priceHigh = this._eventData.find((item) => item.name == 'priceRangeHigh');
        let priceLow = this._eventData.find((item) => item.name == 'priceRangeLow');
        let priceStr = '';
        if (priceHigh?.value || priceLow?.value) {
            if (priceHigh?.value && priceLow?.value) {
                priceStr = `${currencyFormatter.format(priceLow.value)} - ${currencyFormatter.format(priceHigh.value)}`;
            }
            else if (priceLow?.value) {
                priceStr = `From ${currencyFormatter.format(priceLow.value)}`;
            }
            else if (priceHigh?.value) {
                priceStr = `Up to ${currencyFormatter.format(priceHigh.value)}`;
            }
        }
        if (priceStr) {
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${ticket}</div>\n                    <div class="icon_text">\n                        <p><strong>Tickets:</strong></p>\n                        <p>${priceStr}</p>\n                    </div>\n                </div>`);
        }
        let searchParams = new URLSearchParams(window.location.search);
        let eventSearch = searchParams.get('eventsearch') ?? '';
        if (eventSearch) {
            eventSearch = `?eventsearch=${encodeURIComponent(eventSearch)}`;
        }
        if (this.eventData.location) {
            let _address = [
                this.eventData.location?.address1,
                this.eventData.location?.address2,
                this.eventData.location?.city,
                this.eventData.location?.country,
                this.eventData.location?.postcode
            ];
            /* let iconStrings = '';
            if(this.icons){
                iconStrings = this.icons.map(icon=>{
                     if(icon){
                        return html`<li class="icon" title="${icon.label}">
                            <span class="screen-reader-text">${msg(str`${icon.label} icon`)}</span>
                            <span aria-hidden="true">
                                ${unsafeHTML(icon.icon??'')}
                            </span>
                        </li>`;
                    }
                });
            } */
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${address}</div>\n                    <div class="icon_text">\n                        <p><strong>Location:</strong></p>\n                        <p>${this.eventData.location.name}</p>\n                        <address>\n                            ${_address.map(item => html `<p>${item}</p>`)}\n                        </address>\n                        \n                        <a href="${this.hardlinks.listings_locations}/${this.eventData.location.id}${eventSearch}">Find out more about ${this.eventData.location.name}</a>\n                    </div>\n                </div>`);
        }
        if (this.eventData.locationName) {
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${address}</div>\n                    <div class="icon_text">\n                        <p><strong>Location:</strong></p>\n                        <p>${this.eventData.locationName}</p>\n                        <a href="${this.eventData.locationUrl}${eventSearch}">Find out more about ${this.eventData.locationName}</a>\n                    </div>\n                </div>`);
        }
        if (this.eventData.format !== 'Online') {
            let zones = {};
            this.eventData?.instances.forEach(instance => {
                if (instance.zone && !zones[instance.zone.id]) {
                    zones[instance.zone.id] = instance.zone;
                }
            });
            let zoneValues = Object.values(zones);
            let zoneLoop = '';
            if (zoneValues.length > 0) {
                zoneLoop = zoneValues.map(zone => {
                    return html `<li class="margin-bottom"><p><a href="${this.hardlinks.listings_locations}/${this.eventData.location.id}/zone/${zone.id}">Find out more about our ${zone.name}</a><br>${zone.zoneType}</p></li>`;
                });
            }
            if (zoneLoop) {
                loop.push(html `<div class="grid grid--icon">\n                    <div class="icon"></div>\n                    <div class="icon_text">\n                        <ul>\n                        ${zoneLoop}\n                        </ul>\n                    </div>\n                </div>`);
            }
        }
        if (this.eventData.locationUrl && !this.preview) {
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${web}</div>\n                    <div class="icon_text">\n                        <p><strong>Relevant access information:</strong></p>\n                        <p><a href="${this.eventData.locationUrl}" target="_blank">${this.eventData.locationUrl}</a></p>\n                    </div>\n                </div>`);
        }
        /* let alreadyShared = this.membership?.organisationShares?.some(share=>share.organisationId===this.organisation);
        if(this.membership && !alreadyShared){
            loop.push(html`
                <div class="item text">
                    <p><button class="link-btn" @click=${(e) => this._handleShareProfile(e)}>${this.memberShareButtonTextForEvent || msg(`Share profile`)}</button></p>
                </div>
            `);
        }
        if(this.membership && alreadyShared){
            loop.push(html`
                <div class="item text">
                    <p><a href="/dashboard/share"><strong>${this.memberAlreadySharedProfileText || msg(`You have shared your details with this organisation`)}</strong></a></p>
                </div>
            `);
        } */
        if (this.preview == "true") {
            this.eventManager.emit(`allin-navigation-${this.name}`, {
                navigation: [[
                        { title: `Go back to editing`, url: `#`, id: `organisation-dashboard`, callback: this._handleGoBack.bind(this), icon: 'arrowBack' },
                    ]],
                currentPage: '/',
                onlineEventLink: this.eventData.locationUrl ? {
                    title: 'Relevant access information',
                    url: this.eventData.locationUrl,
                    target: '_blank'
                } : null,
                touringEventLocation: this.eventData.locationName ? {
                    title: 'Location',
                    value: this.eventData.locationName
                } : null,
                sidebar: html `\n                    <div class="sidebar preview">${loop}</div>\n                `
            });
        }
        else {
            this.eventManager.emit(`allin-navigation-${this.name}`, {
                navigation: [],
                currentPage: '/',
                sidebar: html `\n                    <div class="sidebar">\n                        <div class="return grid--icon back-to-search">\n                            <a href="#" class="back-to-search-btn" @click=${this._handleGoBack}><span aria-hidden=true>${arrowBack}</span>Go back to search</a>\n                        </div>\n                        <h2 class="screen-reader-text">Event Details</h2>\n                        ${loop}\n                    </div>\n                `
            });
        }
    }
    _handleShareProfile(e = false) {
        if (e) {
            e.preventDefault();
        }
        if (this._modal.open) {
            this._modal.close();
        }
        else {
            this._modal.showModal();
        }
    }
    _cancelShareProfile(e) {
        this._handleShareProfile(e);
    }
    async _confirmShareProfile() {
        this._isSharingProfile = true;
        try {
            const response = await fetch(this.restUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                },
                body: JSON.stringify({
                    action: 'member-dashboard-add-shared-org',
                    org_to_add: this.organisation
                })
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            if (data.error) {
                this._isSharingProfile = false;
                console.error('Error sharing profile:', data.error);
                return;
            }
            if (data.ok) {
                if (data.action_links) {
                    window.location.href = data.action_links;
                }
                else {
                    this._isSharingProfile = false;
                    this._handleShareProfile();
                }
                this.membership = {
                    ...this.membership,
                    organisationShares: [
                        ...(this.membership.organisationShares || []),
                        {
                            organisationId: this.organisation
                        }
                    ]
                };
                this._setSidebar();
            }
        }
        catch (error) {
            this._isSharingProfile = false;
            console.error('Error sharing profile:', error);
        }
    }
    _getAccessibilityIcons(provisions) {
        let accessibilityIcons = [];
        let provisionMap = [];
        this.allProvisions?.forEach(prov => {
            provisionMap = [...provisionMap, ...prov.provisions];
        });
        if (provisions && provisions.length) {
            provisions.forEach(prov => {
                let provision = provisionMap.find(p => p.id === prov.standardId);
                if (provision?.filterCategory && !accessibilityIcons.includes(provision?.filterCategory)) {
                    accessibilityIcons.push(provision?.filterCategory);
                }
            });
        }
        accessibilityIcons.sort();
        accessibilityIcons = accessibilityIcons.map(cat => {
            let icon = this.accessibilities?.find(a => a.name === cat);
            if (icon) {
                return html `<li class="icon" title="${icon.label}">\n                    <span class="screen-reader-text">{icon.label} icon</span>\n                    <span aria-hidden="true">\n                        ${unsafeHTML(icon.icon ?? '')}\n                    </span>\n                </li>`;
            }
        });
        accessibilityIcons = accessibilityIcons.filter(icon => icon);
        return accessibilityIcons;
    }
    _handleGoBack(e) {
        e.preventDefault();
        this.eventManager.emit(`allin-event-go-back-${this.name}`, { hide: true });
    }
    _expandCollapseAll(e) {
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.provisions');
        if (e.currentTarget.classList.contains('expand_all')) {
            targets.forEach(target => {
                target.setAttribute('open', '');
            });
        }
        else {
            targets.forEach(target => {
                target.removeAttribute('open');
            });
        }
    }
    static styles = [
        accessibility,
        grid,
        details,
        dialog,
        css `
        :host{
            width:100%;
        }
        button{
            border:none;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }

        .grid{
            gap:1.5rem;
        }
        h2{
            font-size:1.5rem;
            color:var(--allin-highlight-color,#472961);
        }
        .image-grid{
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            container-type: inline-size;
        }

        .grid--featured{
            flex-basis: 100%;
            background-color: transparent;
            max-height: 450px;
            line-height: 0;
            position: relative;
        }
        .image-container{
            position: relative;
            max-height: 450px;
            width: fit-content;
            margin: 0 auto;
            overflow-x: clip;
        }
        .grid--image {
            flex-shrink: 1;
            flex-grow: 0;
            flex-basis: 0;
            height: 150px;
        }

        .grid--featured img{
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: top;
            line-height: 0;
            max-height: 450px;
        }
        .grid--image:has(:focus){
            outline: 4px solid var(--allin-highlight-color, #472961);       
        }
        .grid--featured img{
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: top;
            line-height: 0;
        }
        .grid--image img{
            width: auto;
            height: 100%;
            object-fit: cover;
            /* object-position: top; */
            max-width: calc(33cqw - 0.67rem);
        }

        .grid--image.selected{
            outline: 4px solid var(--allin-secondary-color,#FFCE58);
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
        }
        .provisions summary{
            padding:1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: flex;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        .provision_text{
            max-width:700px;
            h4{
                margin-top:0;
                margin-bottom:0.5rem;
            }
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
        }
        .collapsers{
            margin-right:auto;
            margin-bottom:1rem;
            display: flex;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }

        .grid--icon {
            grid-template-columns: 1.6rem 1fr;
            gap: 1.5rem;
            margin-bottom: 1rem;
            width: 100%;
        }

        p{
            margin-top:0;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .provisions summary::after {
            right: 1rem;
            top: 1.2rem;
        }

        .instances{
            margin-top:2rem;
            padding-bottom:0;
        }
        .instance-list{
            list-style:none;
            padding:0;  
            margin:0;
        }
        .instance-list .instance{
            display:grid;
            grid-template-columns:1fr auto;
            gap:1rem;
            padding-bottom:1rem;
            position:relative;
            &:after{
                content:'';
                position:absolute;
                left:-2rem;
                right:-2rem;
                bottom:0;
                height:2px;
                background-color:var(--color-grey);
            }
        }

        .instance-list .instance ul{
            padding: 0;
            max-width: 700px;
        }
        
        .instance-list .instance:last-child{
            border-bottom:none;
        }
        .instance-list .instance .arrow{
            align-self:start;
        }
        .instance-list .provision-list{
            list-style:none;
            display:grid;
            grid-template-columns:1fr 1fr ;
            gap:1rem;
            padding:0;
            margin:0;
        }
        @media (min-width:1000px){
            .instance-list .provision-list{
                grid-template-columns:1fr 1fr 1fr ;
            }
        }
        .instance-list .provision-list li{
            padding:0.5rem;
            border-radius:2px;
            border:1px solid #707070;
        }
        .instance-list .provision-list li h4{
            margin-top:0;
            margin-bottom:0;
            font-size:0.8rem;
        }
        .instance_title_grid h3{
            margin-top:0;
            margin-bottom:0;
        }
        .instance:not(:first-child){
            margin-top:1rem;
        }
        .arrow{
            display:flex;
            align-items:center;
            gap:0.5rem;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            text-decoration:underline;
            text-decoration-gap:0.2rem;
            span{
                text-decoration:none;
                transition:transform var(--transition) ease;
            }
            &:hover{
                span{
                    transform:translateX(0.3rem);
                }
            }
        }
        @media (prefers-reduced-motion: reduce) {
            .arrow span:hover{
                transform: none;
            }
        }
        .description{
            margin-top:2rem;
            margin-bottom:2rem;
        }
        .button{
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            font-family:var(--allin-font-family,'Montserrat');
            background-color:var(--allin-button-bg-color,#472961);
            font-size:var(--allin-button-font-size,1rem);
            color:var(--allin-button-text-color,#fff);
            font-weight:(var(--allin-button-font-weight,600));
            cursor:pointer;
            border:none;
            text-decoration:none;
            transition:background-color var(--transition) ease;
            display:block;
            width:100%;
            margin-top:2rem;
            box-sizing: border-box;
            text-align: center;
            &:hover{
                background-color:var(--allin-button-bg-hover-color,#725A88);
            }
        }

        .return a{
            background-color: transparent;
            color: var(--allin-highlight-color, #472961);
            border: 0;
            display: flex;
            gap: 0.5rem;
            align-items: center;
            text-decoration: underline;
            cursor: pointer;
            transition: color var(--transition) ease;
            font-weight: 700;
            font-size: 1.25rem; 
            margin-top:1rem;
        }
        .flex .collapsers{
            margin:0;
        }
        .instance .provisions{
            grid-column: span 2;
        }
        .instances>.button{
            margin-bottom:2rem;
        }
        .provision-icons{
            gap:1rem;
            flex-wrap:wrap;
            padding-right:2rem;
        }

        .share-modal {
            position: fixed;
            inset: 0;
            z-index: 99999;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0,0,0,.5);
        }

        .share-modal-content {
            background: white;
            padding: 0rem;
            max-width: 500px;
            width: calc(100% - 2rem);
            position: relative;
            z-index: 100000;
        }

        .share-modal-content:not(:has(.loading)){
            padding: 2rem;
        }

        .loading {
            display: flex;
            gap: 0.5rem;
            align-items: center;
            justify-content: center;
            padding: 2rem;
            background-color: var(--allin-bg-color,#ccc);
            min-height: 20rem;
            margin: 0;
        }

        .loading::after {
            content: "";
            display: block;
            width: 2rem;
            height: 2rem;
            animation: 1s linear 0s infinite normal none running spin;
            z-index: 100;
            background-image: url("/wp-content/themes/ace/assets/wheel.svg");
            background-size: cover;
        }

        @keyframes spin {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);
            }
        }

        button.btn {
            padding: 1rem;
            border-radius: var(--allin-border-radius, 0.5rem);
            width: fit-content;
            text-align: center;
            font-family: var(--allin-font-family, Montserrat, sans-serif);
            font-size: var(--allin-font-size, 1rem);
            color: var(--allin-button-text-color, #fff);
            font-weight: (var(--allin-button-font-weight, 600));
            cursor: pointer;
            border: none;
            background: var(--allin-button-bg-color, #472961);
            transition: background var(--transition) ease;
        }
        button.btn:hover{
            background: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
            color: rgb(52,52,52);
        }
        
        `
    ];
}
